/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { FC } from 'react'
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars'
import CN from 'classnames'

import './DateTimePicker.scss'

export interface DateTimePickerProps {
  allowEdit?: boolean
  disableWeekends?: boolean
  enabled?: boolean
  format?: string | undefined
  isErrored?: boolean
  minDate?: any
  onChange?: (e: any) => void | undefined
  value?: any
  width?: string | undefined
  [x: string]: any
}

export const DateTimePicker: FC<DateTimePickerProps> = ({
  allowEdit,
  disableWeekends,
  enabled,
  format,
  isErrored,
  minDate,
  onChange,
  value,
  width,
  ...restProps
}: DateTimePickerProps) => {
  /** disable weekends */
  const disabledDate = (args: any) => {
    if (disableWeekends) {
      if (args.date.getDay() === 0 || args.date.getDay() === 6) {
        // set 'true' to disable the weekends
        args.isDisabled = true
      }
    }
  }

  return (
    <div
      className={CN('consign-date-time-picker', {
        '!outline-R-500 !outline-2': isErrored,
      })}>
      <DatePickerComponent
        id='datetimepicker'
        enabled={enabled}
        value={value}
        width={width}
        format={format}
        onChange={onChange}
        allowEdit={allowEdit}
        renderDayCell={disabledDate}
        min={minDate}
        {...restProps}
      />
    </div>
  )
}

DateTimePicker.defaultProps = {
  allowEdit: true,
  disableWeekends: false,
  enabled: true,
  format: 'dd/MM/yyyy',
  minDate: undefined,
  onChange: undefined,
  value: undefined,
  width: undefined,
}

export default DateTimePicker
